export default __webpack_public_path__ + "static/media/bg-pattern-call-to-action.92fe2a1b.svg";